import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { deleteVehicleUrl } from "src/react-query/endPoints";
import { useSelectedCompany } from "src/hooks/useSelectedTeam";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";

export const VehicleActionMenu = ({ id }) => {
  const isReadOnly = useAccess(FEATURE.VEHICLE, "R");
  const hasEditAccess = useAccess(FEATURE.VEHICLE, "U");
  const hasDeleteAccess = useAccess(FEATURE.VEHICLE, "D");
  const company = useSelectedCompany();
  const { mutate } = useMutate("vehicles");

  const onDelete = useCallback(() => {
    mutate({ url: deleteVehicleUrl(company.id, id), method: "DELETE" });
  }, [id, company.id, mutate]);

  //   const assignDriver = useCallback(() => {
  //     dispatch(dialogSlice.actions.setDialog({
  //       open: true,
  //       data: { vehicleId: id, currentDriver: row.driverId },
  //       component: <AssignDriverModal vehicleId={id} currentDriver={row.driverId} />
  //     }));
  //   }, [dispatch, id, row]);

  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `/vehicles/${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `/vehicles/${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
